/* ben: smaller fork of lazy load 
    -- combo of this and remy sharp inview plugin -- emit event by default, no placeholder ... */
/* now relies on lazyload */
require('jqCheckInView'); //todo: take off plugin

(function($) {

    /* the former -- triggers inview event when the element is in view; checked in response to center events */
    $.fn.lazyLoad = function(options) {
        var settings = {
            delay: 100,       /* the throttle value -- the amount of time to wait after the triggering event occurs before checking for visibility */
            container: window,
            skipClass: 'invisible',
            inViewEvent: 'inview', //todo: cb instead?  //trigger internally, then have cb
            eventTriggers: 'scroll checkInView'
        },
        elements = this,
        timeout = null;

        function checkElements() { //todo: filter those already inView ... cache
            var s = settings,
                containerOffsets = $(s.container).getOffsets();

            //todo: should check the container offsets first
            elements.each(function() {
                var $el = $(this); 
                if ( !($el.hasClass(s.skipClass) )) {
                 
                    if ( $el.inView(s.container, {containerOffsets: containerOffsets}) ) {    /* plugin fn req'd in webpack config */

                        $el.trigger(s.inViewEvent)[0].loaded = true;
                        var temp = $.grep(elements, function(elem) {
                            return !elem.loaded;
                        });
                        elements = $(temp);

                    }
                }

            });
        }

        if (options) $.extend(settings, options);

        var $container = settings.container;

        $.each(elements, function() {
            this.loaded = false; //undefined vs bool (store on dom node)
        });

        /* Check if Element are 'InView on these Events -- they trigger 'inview' if inview or 'notinview' if not*/
        $container.on(settings.eventTriggers, function(e) {
            if (timeout) clearTimeout(timeout);
            timeout = setTimeout(function() {
                  checkElements();
                }, settings.delay);
            }
        );

        /* turn off events for the container, and also inview events for all elements its checking */
        $container.on('lazyload.destroy', function(e) {
            //clear all from the container
            $container
                .off('lazyload.destroy')
                .off(settings.eventTriggers);

            $.each(elements, function() {
                $(this).off(settings.inViewEvent);
            });
        });

        return this;
    };


})(jQuery);


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/plugin/jquery.lazyload.js
 ** module id = 458
 ** module chunks = 0
 **/